import { writable } from 'svelte/store';
import collect from 'collect.js';
import { mergeCollectionStore } from '@/Common/Collections.js';
import config from '@/config.js';
// Models
import SportcastFixture from '@/Models/SportcastFixture';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	const { subscribe, set, update } = writable(collect());

	const methods = {
		getSportcastFixturesForComp(compId) {
			if (!config.SPORT_ENABLED) return;

			const sportcastFixture = new SportcastFixture();
			sportcastFixture.resourceUrl = () => {
				return `${sportcastFixture.baseUrl()}/competitions/${compId}/sportcast_fixtures?duration_in_week=2`;
			};

			return sportcastFixture
				.get()
				.then((result) => {
					let allFixtures = collect();
					result.data.map((fixture) => {
						fixture.compId = compId;
						allFixtures.push(fixture);
					});
					mergeCollectionStore(this, allFixtures);
				})
				.catch((e) => {
					console.error(e);
				});
		},

		updateEventMapping(eventId, remoteId = null) {
			if (!config.SPORT_ENABLED) return;

			const sportcastFixture = new SportcastFixture();
			return sportcastFixture.updateEventMapping(eventId, { remote_id: remoteId });
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
